import {
  Input,
  FormField,
  SpaceBetween,
  Container,
  ColumnLayout,
  Header,
  Select,
  RadioGroup,
  Grid,
} from "@cloudscape-design/components-themed";
import { LABELS, PLACE_HOLDER, CONTRACT_ROUTE } from "./constants";
import { Dispatch, SetStateAction } from "react";
import { ExaminationStatusSearchRequest } from "../../features/api-interfaces";
import { DivisionDict, getDivisionLabel } from "../default-constants";

interface IDetailSearchCorporateInfo {
  searchInput: ExaminationStatusSearchRequest;
  setSearchInput: Dispatch<SetStateAction<ExaminationStatusSearchRequest>>;
  corporateNumberErrorMsg: string;
  checkCorporateNumber: (corporateNumber: string) => boolean;
  companyNameErrorMsg: string;
  checkCompanyName: (companyName: string) => boolean;
  merchantNameErrorMsg: string;
  checkMerchantName: (merchantName: string) => boolean;
  comprehensiveMerchantList: DivisionDict[];
}

/**
 * 審査状況・POS登録状況照会 詳細検索 法人情報エリア
 */
export const DetailSearchCorporateInfo = (
  props: IDetailSearchCorporateInfo
) => {
  const {
    searchInput,
    setSearchInput,
    corporateNumberErrorMsg,
    checkCorporateNumber,
    companyNameErrorMsg,
    checkCompanyName,
    merchantNameErrorMsg,
    checkMerchantName,
    comprehensiveMerchantList,
  } = props;
  return (
    <Container header={<Header variant={"h3"}>{LABELS.CORPORATE_INFO}</Header>}>
      <SpaceBetween direction={"vertical"} size={"l"}>
        <ColumnLayout columns={4}>
          <FormField
            label={LABELS.CORPORATE_NUMBER}
            constraintText={PLACE_HOLDER.NUM_LENGTH_THIRTEEN}
            errorText={corporateNumberErrorMsg}
          >
            <Input
              value={searchInput.corporateNumber}
              onChange={({ detail: { value } }) => {
                setSearchInput({ ...searchInput, corporateNumber: value });
                checkCorporateNumber(value);
              }}
            />
          </FormField>
          <FormField
            label={LABELS.COMPANY}
            constraintText={PLACE_HOLDER.CHAR_LENGTH_THIRTY}
            errorText={companyNameErrorMsg}
          >
            <Input
              value={searchInput.companyName}
              onChange={({ detail: { value } }) => {
                setSearchInput({ ...searchInput, companyName: value });
                checkCompanyName(value);
              }}
            />
          </FormField>
          <FormField
            label={LABELS.MERCHANT_NAME}
            constraintText={PLACE_HOLDER.CHAR_LENGTH_FIFTEEN}
            errorText={merchantNameErrorMsg}
          >
            <Input
              value={searchInput.merchantName}
              onChange={({ detail: { value } }) => {
                setSearchInput({ ...searchInput, merchantName: value });
                checkMerchantName(value);
              }}
            />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={4}>
          <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
            <FormField label={LABELS.CONTRACT_ROUTE}>
              <RadioGroup
                items={[
                  {
                    value: "1",
                    label: CONTRACT_ROUTE.ALL,
                  },
                  {
                    value: "2",
                    label: CONTRACT_ROUTE.DIRECT,
                  },
                  {
                    value: "3",
                    label: CONTRACT_ROUTE.COMPREHENSION,
                  },
                ]}
                onChange={({ detail: { value } }) =>
                  setSearchInput({
                    ...searchInput,
                    contractRoute: value,
                    contractRouteName: "",
                  })
                }
                value={searchInput.contractRoute}
              />
            </FormField>
            <FormField
              label={LABELS.BLANK}
              constraintText="　　　　　　　　　　　　　"
            >
              <Select
                disabled={searchInput.contractRoute !== "3"}
                selectedOption={{
                  value: searchInput.contractRouteName,
                  label: getDivisionLabel(
                    comprehensiveMerchantList,
                    searchInput.contractRouteName
                  ),
                }}
                options={comprehensiveMerchantList}
                filteringType="auto"
                onChange={({ detail: { selectedOption } }) =>
                  setSearchInput({
                    ...searchInput,
                    contractRouteName: selectedOption.value!,
                  })
                }
              />
            </FormField>
          </Grid>
        </ColumnLayout>
      </SpaceBetween>
    </Container>
  );
};
